export const ADD_MASTER_DROPDOWNS = "ADD_MASTER_DROPDOWNS";
export const UPDATE_EMPLOYEE_DETAILS = "UPDATE_EMPLOYEE_DETAILS";
